import { CircularProgress } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';

export const statusBarDefaultConfig = {
  backgroundColor: getColor('titanWhite'),
  statusView: ''
};

export const getStatusBarViewConfig = ({
  isLoading,
  enabled,
  renderEnabled,
  renderDisabled
}) => {
  if (isLoading) {
    return {
      backgroundColor: getColor('titanWhite'),
      Icon: <CircularProgress size={20} />
    };
  }
  switch (enabled) {
    case true:
      return {
        backgroundColor: getColor('feta'),
        statusView: renderEnabled,
        Icon: <Icon name='CheckCircleOutlineIcon' color='funGreen' />
      };
    case false:
      return {
        backgroundColor: getColor('titanWhite'),
        statusView: renderDisabled,
        Icon: <Icon name='HighlightOff' color='shuttleGray' />
      };
  }
};
